/* Sivena advertorial (nsr2) — font enforcement + evergreen countdown */
(function applyFonts(){
  var SERIF="'Merriweather', Georgia, serif", SANS="'Montserrat', system-ui, sans-serif";
  var serifSels=['.hed','.sh h2','.op-product-name','.op-recommended span'];
  var sansSels=['.body p','.cta-btn','.cta-sub','.cta-link','.sub-hed','.read-time','.byline',
    '.breadcrumb','.top-nav','.check-list li','.fail-list li','.doc-quote p','.testimonial',
    '.pathway-card','.pathway-bottom','.offer-bullets li','.offer-guarantee','.op-timer','.op-digit','.footer'];
  var applying=false;
  function setIf(el,p,v){ if(el.style.getPropertyValue(p)!==v||el.style.getPropertyPriority(p)!=='important'){el.style.setProperty(p,v,'important');} }
  function run(){
    var root=document.querySelector('.ns-adv'); if(!root) return; applying=true;
    serifSels.forEach(function(s){ root.querySelectorAll(s).forEach(function(el){ setIf(el,'font-family',SERIF); }); });
    sansSels.forEach(function(s){ root.querySelectorAll(s).forEach(function(el){ setIf(el,'font-family',SANS); setIf(el,'letter-spacing','0px'); }); });
    applying=false;
  }
  run(); [0,50,100,200,300,500,800,1200,2000,3500].forEach(function(t){setTimeout(run,t);});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run);
  window.addEventListener('load',run);
  if(window.MutationObserver){ var root=document.querySelector('.ns-adv');
    if(root){ new MutationObserver(function(m){ if(applying) return; for(var i=0;i<m.length;i++){ if(m[i].type==='attributes'||m[i].type==='childList'){run();return;} } }).observe(root,{attributes:true,attributeFilter:['style','class'],childList:true,subtree:true}); } }
})();
(function countdown(){
  var root=document.querySelector('.ns-adv'); if(!root) return;
  var digits=root.querySelectorAll('.op-digit'); if(digits.length<3) return;
  function pad(n){ return (n<10?'0':'')+n; }
  function endOfDay(){ var e=new Date(); e.setHours(23,59,59,0); if(new Date()>=e) e.setDate(e.getDate()+1); return e; }
  var end=endOfDay();
  function tick(){
    var diff=end-new Date(); if(diff<=0){ end=endOfDay(); diff=end-new Date(); }
    var h=Math.floor(diff/3600000), m=Math.floor((diff%3600000)/60000), s=Math.floor((diff%60000)/1000);
    digits[0].innerHTML=pad(h)+'<span class="op-digit-label">h</span>';
    digits[1].innerHTML=pad(m)+'<span class="op-digit-label">min</span>';
    digits[2].innerHTML=pad(s)+'<span class="op-digit-label">s</span>';
  }
  tick(); setInterval(tick,1000);
})();
